module.exports = __webpack_public_path__ + "img/icon14.1ed77ed8.png";